/*
 * Jira Ticket:
 * Created Date: Fri, 17th Jan 2020, 16:22:17 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

//  add your resource name mapping here (resource_name: api_name)
export default {
  User: 'User',
  Organisation: 'Organisation',
  Project: 'Project',
  Site: 'Site',
  Employment: 'Employment',
  Subcontract: 'Subcontract',
  Tower: 'Tower',
  TowerType: 'TowerType',
  Inspection: 'TowerInspection',
  // Qualification: 'Qualification', // removed due to PAS-608
  Region: 'Region',
  Country: 'Country',
  Locale: 'Locale',
  Advert: 'Advert',
  Configuration: 'ConfigurationItem',
  SubscriptionTier: 'SubscriptionTier',
  Capabilities: 'Capabilities',
  UserOrgRoles: 'UserOrgRoles',
  Template: 'Template',
  OrganisationSearch: 'OrganisationSearch',
};
